import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'luvf-634c7';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // Custom domain (matches app origin) so OAuth signInWithRedirect/popup work on
  // browsers that block third-party storage (Safari 16.1+/iOS, Firefox, Chrome 115+).
  // Firebase Hosting auto-serves the /__/auth/handler on this domain.
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'luv.wtf',
  projectId,
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || `${projectId}.firebasestorage.app`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (
  !firebaseConfig.apiKey ||
  !firebaseConfig.messagingSenderId ||
  !firebaseConfig.appId ||
  !firebaseConfig.measurementId
) {
  throw new Error(
    'Missing Firebase web config: set REACT_APP_FIREBASE_API_KEY, MESSAGING_SENDER_ID, APP_ID, and MEASUREMENT_ID (see .env.example).',
  );
}

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

/**
 * App Check (reCAPTCHA v3). Register the web app in Firebase Console → App Check, then set
 * REACT_APP_RECAPTCHA_V3_SITE_KEY to the reCAPTCHA v3 site key shown there.
 * Enable Authentication → Sign-in method → Anonymous (used so pre-signup collage flows can call HTTPS functions).
 * Email link (passwordless): enable Email link on the Email/Password provider; sign-in is completed in index.js (before React) per https://firebase.google.com/docs/auth/web/email-link-auth
 * Local dev: optional REACT_APP_APPCHECK_DEBUG_TOKEN (see Firebase App Check debug provider docs).
 */
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
let appCheck = null;
if (typeof window !== 'undefined' && appCheckSiteKey) {
  const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  if (debugToken) {
    window.self.FIREBASE_APPCHECK_DEBUG_TOKEN =
      debugToken === 'true' || debugToken === '1' ? true : debugToken;
  }
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export { db, auth, analytics, storage, appCheck };
